import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import { appendFormData } from "../../../../helpers/functions/form-append";
import DashboardLayout from "../../../../components/LayoutContainers/DashboardLayout";
import MDBox from "../../../../components/MDs/MDBox";
import MDTypography from "../../../../components/MDs/MDTypography";
import Filter from "./components/filter";
import TableStatistic from "./components/table/table";
import LoadingProgress from "../../../../components/LoadingProgress";
import AppConfig from "../../../../helpers/constants/AppConfig";

function Statistics() {
  const userType = JSON.parse(localStorage.getItem("user")).type;
  const [filterData, setFilterData] = useState({
    owner: "all",
    domain: userType === 0 ? "all" : "",
    group: userType === 0 ? "all" : "",
    from: "",
    to: ""
  });
  const [unit, setUnit] = useState("GiB");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const getStatistics = () => {
    setLoading(true);
    const fromData = appendFormData(filterData);

    api.post(ApiUrls.reports.statistic, fromData)
      .then((response) => {
        setLoading(false);
        setData(response.data);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  return (
    <DashboardLayout>

      <MDBox py={1}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <Card sx={{ height: "100%", py: 4, px: 2 }}>
              <Filter
                filterData={filterData}
                setFilterData={setFilterData}
                unit={unit}
                setUnit={setUnit}
                getStatistics={getStatistics}
              />
            </Card>
          </Grid>

          {data && !loading &&
            <>
              <TableStatistic data={[data.total]} unit={unit} isTotal />

              <Grid item xs={12}>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <MDTypography variant="h6" color="white">
                      جزئیات
                    </MDTypography>
                  </AccordionSummary>

                  <AccordionDetails className="acc-st">
                    <TableStatistic data={data.result} unit={unit} />
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </>
          }

          {loading &&
            <Grid item xs={12}>
              <LoadingProgress color={AppConfig.color} />
            </Grid>
          }

        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default Statistics;
